<script lang="ts">
  import { Col, Progress, Row } from "sveltestrap";
  import Card from "../../Core/Card.svelte";
</script>

<Card cardProps="xl-none" cardBodyprops="ecommerce-widget">
  <div slot="contentbody">
    <Row>
      <Col xs="6"
        ><span>New Order</span>
        <h3 class="total-num counter">25639</h3>
      </Col>
      <Col xs="6">
        <div class="text-end">
          <ul>
            <li>
              Profit<span class="product-stts font-primary m-l-10"
                >8989<i class="icon-angle-up f-12 m-l-10" /></span
              >
            </li>
            <li>
              Loss<span class="product-stts font-primary m-l-10"
                >2560<i class="icon-angle-down f-12 m-l-10" /></span
              >
            </li>
          </ul>
        </div>
      </Col>
    </Row>
    <div class="progress-showcase">
      <div class="progress sm-progress-bar">
        <Progress class="bg-primary" role="progressbar" style="width: 70%" />
      </div>
    </div>
  </div>
</Card>
